import { MutableRefObject, useEffect, useRef, useState } from 'react';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import BtnDownload from './BtnDownload';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const Icon = (props: any) => {
    return (
        <div className="ef-icon-replay" {...props}>
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="30" height="30" rx="15" fill="#707070" />
                <path d="M9.54492 8.18188L13.6358 8.18188L13.6358 12.2728" stroke="white" strokeWidth="1.36364" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M17.0446 9.89325C18.2994 10.3353 19.3765 11.1733 20.1137 12.2807C20.8509 13.3882 21.2082 14.7053 21.1317 16.0335C21.0553 17.3617 20.5493 18.6291 19.6899 19.6447C18.8305 20.6603 17.6644 21.3691 16.3671 21.6643C15.0699 21.9595 13.7118 21.8251 12.4976 21.2814C11.2834 20.7377 10.2788 19.8141 9.63512 18.6497C8.99146 17.4854 8.74364 16.1434 8.929 14.826C9.11435 13.5086 9.72284 12.2871 10.6628 11.3455L13.6355 8.18188"
                    stroke="white"
                    strokeWidth="1.36364"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};

export default function TheComp() {
    const { useLang } = useGlobal();
    const { t } = useLang('theProduct.ManagementSoftware');

    // 滑到自动播放
    const moduleRef = useRef<HTMLDivElement>(null);
    const [startPlay, setStartPlay] = useState(false);
    const onePlay = useRef(false); // 只播放一次
    useEffect(() => {
        if (!moduleRef.current) return;
        const playEventListener = new IntersectionObserver(
            (entrys) => {
                if (onePlay.current) return;
                if (entrys[0].isIntersecting) {
                    onePlay.current = true;
                    setStartPlay(entrys[0].isIntersecting);
                }
            },
            {
                root: document,
                threshold: 0.5,
            },
        );
        playEventListener.observe(moduleRef.current);

        return () => {
            playEventListener.disconnect();
        };
    }, []);
    return (
        <div className={styles.TheComp} ref={moduleRef}>
            <EfSpec />
            <EfSection
                hasAnimation={false}
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
                isVideo
                Icon={Icon}
                startPlay={startPlay}
                poster="https://websiteoss.ecoflow.com/upload/image/1732333050041/ManagementSoftware-pc2.jpg"
                pc="https://websiteoss.ecoflow.com/upload/video/1732873012532/video2.mp4"
            />
            <BtnDownload text={t('download')} />
            <EfSpec />
        </div>
    );
}
